import React from 'react';

export const Logo = ({ style, width = 72, height = 72 }) => (
    <img src="asg-logo.png" style={style} width={width} height={height} alt="logo" />
)